/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface RtSystemQuantityScopeDto
 */
export interface RtSystemQuantityScopeDto {
    /**
     * 
     * @type {string}
     * @memberof RtSystemQuantityScopeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RtSystemQuantityScopeDto
     */
    rtSystemCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RtSystemQuantityScopeDto
     */
    rtSystemSubCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RtSystemQuantityScopeDto
     */
    readonly name?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof RtSystemQuantityScopeDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof RtSystemQuantityScopeDto
     */
    $type?: RtSystemQuantityScopeDtoTypeEnum;
}


/**
 * @export
 */
export const RtSystemQuantityScopeDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoRtSystemQuantityScopeDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.RtSystemQuantityScopeDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RtSystemQuantityScopeDtoTypeEnum = typeof RtSystemQuantityScopeDtoTypeEnum[keyof typeof RtSystemQuantityScopeDtoTypeEnum];



/**
 * Check if a given object implements the RtSystemQuantityScopeDto interface.
 */
export function instanceOfRtSystemQuantityScopeDto(value?: unknown): value is RtSystemQuantityScopeDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RtSystemQuantityScopeDtoTypeEnum)[0];
}

export function RtSystemQuantityScopeDtoFromJSON(json: any): RtSystemQuantityScopeDto {
    return RtSystemQuantityScopeDtoFromJSONTyped(json, false);
}

export function RtSystemQuantityScopeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RtSystemQuantityScopeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'rtSystemCategory': json['rtSystemCategory'] == null ? undefined : json['rtSystemCategory'],
        'rtSystemSubCategory': json['rtSystemSubCategory'] == null ? undefined : json['rtSystemSubCategory'],
        'name': json['name'] == null ? undefined : json['name'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function RtSystemQuantityScopeDtoToJSON(value?: Omit<RtSystemQuantityScopeDto, 'name'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'rtSystemCategory': value['rtSystemCategory'],
        'rtSystemSubCategory': value['rtSystemSubCategory'],
        'origin': EntityOriginToJSON(value['origin']),
        '$type': value['$type'],
    });
}

